import { createReducer } from '@reduxjs/toolkit'

import { companyLoggedIn, companyLoggedOut, loggedInClubOne, updateCompanyIdFieldValue } from '../actions/actions'

export const initialState = {
  address: {},
  agentRequired: false,
  companyId: '',
  companyIdFieldValue: '',
  hasAgent: false,
  name: '',
  valid: true
}

const company = createReducer(initialState, {
  [companyLoggedIn]: (state, { payload }) => {
    state.address = payload.address
    state.agentRequired = payload.agentRequired
    state.companyId = payload.companyId
    state.hasAgent = payload.hasAgent
    state.name = payload.name
    state.valid = payload.valid
  },
  [companyLoggedOut]: () => initialState,
  [updateCompanyIdFieldValue]: (state, { payload }) => {
    state.companyIdFieldValue = payload
  },
  [loggedInClubOne]: () => initialState
})

export default company
